import React, { PropsWithChildren } from 'react'
import { Trans } from 'react-i18next'
import Badge from 'client/components/core/Badge'
import EntityExampleWrapperUi from 'client/components/core/EntityExampleWrapper/ui/EntityExampleWrapperUi'

export interface EntityExampleWrapperProps {
  label: string
  warning?: boolean
  visible?: boolean
  skipTranslation?: boolean
}

const EntityExampleWrapperNew = ({
  children,
  label,
  warning = true,
  visible = true,
  skipTranslation,
}: PropsWithChildren<EntityExampleWrapperProps>) => {
  if (!visible) {
    return <>{children}</>
  }

  return (
    <EntityExampleWrapperUi>
      {children}
      <Badge warning={warning}>
        {/*@ts-ignore*/}
        {skipTranslation ? label : <Trans parent="span">{label}</Trans>}
      </Badge>
    </EntityExampleWrapperUi>
  )
}

export default EntityExampleWrapperNew
